import React from 'react'
import { useIntl } from 'react-intl'
import {
  StandingOrderType,
  standingOrderCalculation,
  OrderProductLineItem
} from 'msp-integrations'
import translations from '../../AccountOrders/AccountOrderDetail/OrderTransactionSummary/OrderTransactionSummary.constants'
import * as S from '../../AccountOrders/AccountOrderDetail/OrderTransactionSummary/OrderTransactionSummary.styles'
import standingTranslations from './StandingOrdersDetails.constants'

const StandingOrdersDetailsSummaryTotal = ({
  order,
  products
}: {
  order: StandingOrderType
  products: OrderProductLineItem[]
}) => {
  const { formatMessage, formatNumber } = useIntl()
  const pricing = standingOrderCalculation(
    products,
    order?.c_standingOrderCoupon ? undefined : order?.c_orderingShipping
  )

  return (
    <div className={`font-Roboto text-14 ${S.Wrapper}`}>
      <div className={S.ContentWrapper}>
        <div className={S.SummaryItemWrapper}>
          <div className={S.SummaryItemName}>
            {formatMessage(translations.summaryTotalProducts)}
          </div>
          <div className={S.SummaryItemValue}>
            {formatNumber(pricing.netValue, {
              style: 'currency',
              currency: pricing.currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div>
        <div className={S.SummaryItemWrapper}>
          <div className={S.SummaryItemName}>
            {formatMessage(translations.summaryShipping)}
          </div>
          <div className={S.SummaryItemValue}>
            {formatNumber(pricing.shipping, {
              style: 'currency',
              currency: pricing.currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div>
        {/* removed due to discrepancy to order calcs, will be fixed after doing standing order calc on BE  */}
        {/* <div className={S.SummaryItemVatWrapper}>
          <div className={S.SummaryItemName}>
            {formatMessage(translations.summaryVAT)}
          </div>
          <div className={S.SummaryItemValue}>
            {formatNumber(pricing.tax, {
              style: 'currency',
              currency: pricing.currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div> */}
        <div className={S.SummaryItemTotalPriceWrapper}>
          <div className={S.SummaryItemName}>
            {formatMessage(standingTranslations.summaryOrderTotal)}
            <div className={S.SummaryItemTotalPriceIncVAT}>
              {formatMessage(translations.summaryOrderVAT)}
            </div>
          </div>
          <div className={S.SummaryItemValue}>
            {formatNumber(pricing.total, {
              style: 'currency',
              currency: pricing.currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div>
        <div className={S.SummaryItemTotalPriceIncVAT}>
          {formatMessage(standingTranslations.vary)}
        </div>
      </div>
    </div>
  )
}

export default StandingOrdersDetailsSummaryTotal
